
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Redirect, Switch } from "react-router-dom";
import { Provider } from "react-redux";

import PublicRoute from "./components/PublicRoute";
import Loader from "./components/Loader";
import Header from './components/Header';
import Index from "./pages/Index";


let Home = lazy(() => import("./pages/home/Home"));
let BharatForm = lazy(() => import("./pages/bharat/BharatForm"));
let InstituteFormHome = lazy(() => import("./pages/InstituteFormHome"));
let Login = lazy(() => import("./pages/formProcess/Login"));
let PrintDetails = lazy(() => import("./pages/formProcess/PrintDetails"));
let PaymentStatus = lazy(() => import("./pages/formProcess/PaymentStatus"));
let InstituteFormAdd = lazy(() => import("./pages/InstituteFormAdd"));


let DALMIAForm = lazy(() => import("./pages/dalmia/DALMIAForm"));
let DalmiaFillRegistration = lazy(() => import("./pages/dalmia/DalmiaFillRegistration"));
let PrimaryForm = lazy(() => import("./pages/dalmia/PrimaryForm2"));
let SuccessPage = lazy(() => import("./pages/dalmia/SuccessPage"));



function App(props) {


  function renderRoutes(){
    return(
      <Provider store={props.store}>
        <BrowserRouter>
        <Index>
        <Header {...props} />
            <Suspense fallback={<Loader show={true} />} >
              <Switch>
              <Redirect exact from="/" to="/home/form?merchantType=1" />
                <PublicRoute exact path={`/home/:form`} component={Home} />
                <PublicRoute exact path={`/OnlineAdmissionPortal/:formId/onlineFormProcess/login`} component={Login} />
                <PublicRoute exact path={`/OnlineAdmissionPortal/onlineFormProcess/printFormDetails`} component={PrintDetails} />
                <PublicRoute exact path={`/OnlineAdmissionPortal/payment/view/status`} component={PaymentStatus} />
                <PublicRoute exact path={`/OnlineAdmissionPortal/bharat/home`} component={BharatForm} />
                <PublicRoute exact path={`/OnlineAdmissionPortal/:formId/home`} component={InstituteFormHome} />
                <PublicRoute exact path={`/OnlineAdmissionPortal/:formAddId/add`} component={InstituteFormAdd} />
                <PublicRoute exact path={'/OnlineAdmissionPortal/dalmia/info'} component={DALMIAForm}/>
                <PublicRoute exact path={'/OnlineAdmissionPortal/dalmia/primarychecklist'} component={DalmiaFillRegistration}/>
                <PublicRoute exact path={'/OnlineAdmissionPortal/dalmia/primaryform2'} component={PrimaryForm}/>
                <PublicRoute exact path={`/OnlineAdmissionPortal/onlineFormProcess/successpage`} component={SuccessPage} />
              </Switch>
            </Suspense>
          </Index>
        </BrowserRouter>
      </Provider>
    )
  }

  return (
    <div className="home-color">
      {renderRoutes()}
    </div>
   
  );
}

export default App;
